import { render, staticRenderFns } from "./StudentCourses.vue?vue&type=template&id=6990599f&scoped=true"
import script from "./StudentCourses.vue?vue&type=script&lang=js"
export * from "./StudentCourses.vue?vue&type=script&lang=js"
import style0 from "./StudentCourses.vue?vue&type=style&index=0&id=6990599f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6990599f",
  null
  
)

export default component.exports